import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { Power, PowerOff, Tune } from "@mui/icons-material";

const PowerControlCard = ({ device, onPowerOn, onPowerOff }) => {
  const [confirmAction, setConfirmAction] = useState(null);

  const powerState = device?.power_state;
  const isOnline = device?.status === "ONLINE";

  const handleConfirm = () => {
    if (confirmAction === "powerOn") onPowerOn();
    if (confirmAction === "powerOff") onPowerOff();
    setConfirmAction(null);
  };

  const dialogMessages = {
    powerOn: {
      title: "Power On",
      text: "Are you sure you'd like to turn the power on?",
    },
    powerOff: {
      title: "Power Off",
      text: "Are you sure you'd like to turn the power off? The device will go offline.",
    },
  };

  return (
    <>
      <Card sx={{ height: "100%" }}>
        <CardContent>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <Tune sx={{ fontSize: 22, color: "text.secondary" }} />
            <Typography variant="subtitle1" fontWeight="bold">
              Power Control
            </Typography>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <ToggleButtonGroup
            value={powerState}
            disabled={!isOnline}
            onChange={(e, newState) => {
              if (newState === "OFF") setConfirmAction("powerOff");
              if (newState === "ON") setConfirmAction("powerOn");
            }}
            exclusive
            fullWidth
            size="small"
          >
            <ToggleButton value="ON">
              <Power sx={{ mr: 0.5 }} /> On
            </ToggleButton>
            <ToggleButton value="OFF" disabled={!device?.enable_power_off}>
              <PowerOff sx={{ mr: 0.5 }} /> Off
            </ToggleButton>
          </ToggleButtonGroup>

          {!device?.enable_power_off && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 0.5, display: "block" }}
            >
              Power off is disabled for this device
            </Typography>
          )}
        </CardContent>
      </Card>

      <Dialog open={!!confirmAction} onClose={() => setConfirmAction(null)}>
        <DialogTitle>
          {confirmAction && dialogMessages[confirmAction]?.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmAction && dialogMessages[confirmAction]?.text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmAction(null)}>Cancel</Button>
          <Button variant="contained" onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PowerControlCard;
